import React from 'react';
import classNames from 'classnames';
import { IconArrowHead, IconPlay, ResponsiveImage } from '../../../components';

import css from './ListingImageGallery.module.css';

export const createGalleryRenderers = ({
  items,
  galleryRef,
  showNav,
  setShowNav,
  handleThumbnailClick,
  thumbVariants,
  thumbnailRefs,
  optimizedImages,
}) => {
  // The thumbnail needs optimizedImages as much as the slide does: without it,
  // ResponsiveImage falls back to the image's own variants, which for a dealer
  // listing are the dealer's URL, so the strip showed the dealer's original,
  // watermark included, under a slide whose overlay had been removed. Matched
  // by sourceUrl rather than index, so it holds when an image was deleted.
  const renderThumbInner = item => (
    <div className={css.thumbWrapper} ref={el => (thumbnailRefs.current[item.index] = el)}>
      <ResponsiveImage
        rootClassName={css.thumb}
        image={item.image}
        alt={item.thumbAlt}
        variants={thumbVariants}
        sizes="200px"
        optimizedImages={optimizedImages}
      />
      {item.isVideo ? (
        <div className={css.videoThumbnailOverlay}>
          <IconPlay />
        </div>
      ) : null}
    </div>
  );

  const renderLeftNav = (onClick, disabled) => (
    <button
      className={classNames(css.navLeft, { [css.hidden]: !showNav })}
      onMouseEnter={() => setShowNav(true)}
      onMouseLeave={() => setShowNav(false)}
      disabled={disabled}
      onClick={e => {
        onClick(e);
        const wasFirstItem = galleryRef.current.state.currentIndex - 1 < 0;
        handleThumbnailClick(e, wasFirstItem ? items.length - 1 : galleryRef.current.state.currentIndex - 1);
      }}
    >
      <div className={css.navArrowWrapper}>
        <IconArrowHead direction="left" size="big" />
      </div>
    </button>
  );

  const renderRightNav = (onClick, disabled) => (
    <button
      className={classNames(css.navRight, { [css.hidden]: !showNav })}
      onMouseEnter={() => setShowNav(true)}
      onMouseLeave={() => setShowNav(false)}
      disabled={disabled}
      onClick={e => {
        onClick(e);
        const wasLastItem = items.length === galleryRef.current.state.currentIndex + 1;
        handleThumbnailClick(e, wasLastItem ? 0 : galleryRef.current.state.currentIndex);
      }}
    >
      <div className={css.navArrowWrapper}>
        <IconArrowHead direction="right" size="big" />
      </div>
    </button>
  );

  return { renderThumbInner, renderLeftNav, renderRightNav };
};
